(() => {
  const tileSelector = '.custom-upsell-grid-item';
  const originalDisplay = new WeakMap();
  let cart;
  let revision = 0;
  let needsRead = false;
  let reading = false;
  let timer;

  function apply() {
    if (!cart) return;
    const hasPack = cart.items.some((item) => {
      const title = (item.title || '').toLowerCase();
      return (item.handle || '').includes('3-pack') || title.includes('3-pack') || title.includes('mega ice pack');
    });
    document.querySelectorAll(tileSelector).forEach((tile) => {
      if (hasPack && tile.innerText.includes('Starter')) {
        if (!originalDisplay.has(tile)) originalDisplay.set(tile, tile.style.display);
        tile.style.display = 'none';
      } else if (originalDisplay.has(tile)) {
        tile.style.display = originalDisplay.get(tile);
        originalDisplay.delete(tile);
      }
    });
  }

  function accept(next) {
    if (!next || !Array.isArray(next.items)) return false;
    cart = next;
    revision += 1;
    needsRead = false;
    apply();
    return true;
  }

  async function refresh() {
    if (reading || !needsRead || !document.querySelectorAll(tileSelector).length) return;
    reading = true;
    needsRead = false;
    const startedAt = revision;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const type = response.headers.get('content-type') || '';
      if (!response.ok || !/(?:json|javascript)/i.test(type)) {
        throw new Error(`Cart read returned HTTP ${response.status} (${type || 'unknown content type'})`);
      }
      const next = await response.json();
      if (!next || !Array.isArray(next.items)) throw new Error('Cart response is missing items');
      // An app event may have delivered a newer cart while this read was in flight.
      if (revision === startedAt) accept(next);
    } catch (error) {
      // Preserve the last known state. Only a new cart change can request another read.
      console.warn('Mixed-cart upsells could not refresh cart state:', error.message);
    } finally {
      reading = false;
      if (needsRead) scheduleRead();
    }
  }

  function scheduleRead() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  try {
    accept(JSON.parse(document.getElementById('MixedCartInitialState').textContent));
  } catch (error) {
    console.warn('Mixed-cart upsells initial state is unavailable:', error.message);
  }

  // Upcart's additive public events carry a complete cart; do not overwrite app callbacks.
  ['cart-loaded', 'cart-updated'].forEach((name) => {
    window.addEventListener(`aftersell-upcart:public-events:${name}`, (event) => accept(event.detail?.cart));
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const next = event.cartData;
      if (typeof next?.item_count === 'number' && accept(next)) return;
      // Add responses describe added lines, not necessarily the complete cart.
      revision += 1;
      needsRead = true;
      scheduleRead();
    });
  }

  // Rendering only reapplies known state; unrelated page mutations never fetch cart data.
  new MutationObserver((records) => {
    const relevant = records.some((record) =>
      record.target?.closest?.(tileSelector) || Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 && (node.matches(tileSelector) || node.querySelector(tileSelector))
      )
    );
    if (!relevant) return;
    apply();
    if (needsRead) scheduleRead();
  }).observe(document.body, { childList: true, subtree: true });
})();
